import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import moment from 'moment'

import { planTypeForValue } from '_utils/planType'

import styles from '../styles.css'
import {
  reactTableProps,
  tableProps,
  theadGroupProps,
  theadGroupTrProps,
  theadGroupThProps,
  theadProps,
  theadTrProps,
  theadThProps,
  tBodyProps,
  trGroupProps,
  trProps,
  thProps,
  tdProps,
} from '../styles'

const columns = [
  {
    id: 'name',
    Header: 'Name',
    accessor: user => `${user.name.first} ${user.name.last}`,
  },
  {
    id: 'email',
    Header: 'Email',
    accessor: 'email',
  },
  {
    id: 'day',
    Header: 'Day',
    minWidth: 20,
    accessor: a => a.logsWithin.today,
  },
  {
    id: 'week',
    Header: 'Week',
    minWidth: 20,
    accessor: a => a.logsWithin.week,
  },
  {
    id: 'month',
    Header: 'Month',
    minWidth: 20,
    accessor: a => a.logsWithin.month,
  },
  {
    id: 'year',
    Header: 'Year',
    minWidth: 20,
    accessor: a => a.logsWithin.year,
  },
  {
    id: 'ever',
    Header: 'Ever',
    minWidth: 20,
    accessor: a => a.logsWithin.ever,
  },
]

class LogWithinTable extends PureComponent {
  static propTypes = {
    logsWithinList: PropTypes.array,
  }

  static defaultProps = {
    logsWithinList: [],
  }

  state = {
    logsWithinList: [],
  }

  componentDidMount() {
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = ({ logsWithinList }) => {
    this.setState({ logsWithinList })
  }

  getTrProps = (state, rowInfo) => {
    return {}
  }

  filter = (filter, row, column) => {
    const id = filter.pivotId || filter.id
    if (row[id] !== undefined) {
      if (id === 'name' || id === 'email') {
        return String(row[id])
          .toLowerCase()
          .startsWith(filter.value.toLowerCase())
      } else {
        return +filter.value <= row[id]
      }
    }
    return true
  }

  render() {
    const { logsWithinList } = this.state

    return (
      <ReactTable
        className={classnames(styles.ReactTable, '-highlight')}
        data={logsWithinList}
        columns={columns}
        filterable
        defaultFilterMethod={this.filter}
        getProps={reactTableProps}
        getTableProps={tableProps}
        getTheadGroupProps={theadGroupProps}
        getTheadGroupTrProps={theadGroupTrProps}
        getTheadGroupThProps={theadGroupThProps}
        getTheadProps={theadProps}
        getTheadTrProps={theadTrProps}
        getTheadThProps={theadThProps}
        getTbodyProps={tBodyProps}
        getTrGroupProps={trGroupProps}
        getTrProps={this.getTrProps}
        getThProps={thProps}
        getTdProps={tdProps}
        showPageSizeOptions={false}
        defaultPageSize={20}
      />
    )
  }
}

export default LogWithinTable



// WEBPACK FOOTER //
// ./src/views/admin/components/LogWithinTable.js